
import { Options, Vue } from 'vue-class-component'
import { MDCSnackbar } from '@material/snackbar'

@Options({
  props: ['messageContent'],
  components: { MDCSnackbar },
  watch: {
    messageContent () {
      this.showMessage()
    }
  }
})

export default class ShowMessage extends Vue {
  snackbar: MDCSnackbar|null = null
  mounted () {
    this.initMessage()
  }

  initMessage () {
    const snackbarEl = document.querySelector('.mdc-snackbar') as Element
    this.snackbar = new MDCSnackbar(snackbarEl)
  }

  showMessage () {
    if (this.snackbar != null && this.$props.messageContent !== '') {
      this.snackbar.labelText = this.$props.messageContent
      this.snackbar.open()
    }
  }
};
